<template>
  <div v-if="visible" class="gl-dialog-mask" @click="handleMaskClick">
    <div class="gl-dialog-wrap" @click.stop>
      <div class="gl-dialog">
        <!-- 头部 -->
        <div class="gl-dialog-header">
          <span class="gl-dialog-title">{{ title }}</span>
          <span v-if="showClose" class="gl-dialog-close" @click="handleClose">×</span>
        </div>
        <!-- 内容插槽 -->
        <div class="gl-dialog-body">
          <slot></slot>
        </div>
        <!-- 底部插槽 -->
        <div v-if="$slots.footer" class="gl-dialog-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlDialog',
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      default: ''
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 点击遮罩是否关闭弹窗
    closeOnClickMask: {
      type: Boolean,
      default: true
    },
    // 弹窗宽度
    width: {
      type: String,
      default: '500px'
    }
  },
  watch: {
    visible(val) {
      // 打开弹窗禁止页面滚动
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  methods: {
    handleMaskClick() {
      if (this.closeOnClickMask) {
        this.handleClose();
      }
    },
    handleClose() {
      // 更新父组件 visible，v‑model 原理
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
}
</script>

<style scoped lang="scss">
.gl-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gl-dialog-wrap {
  // 阻止事件冒泡
}

.gl-dialog {
  background: #ffffff;
  border-radius: 4px;
  width: v‑bind(width);
  max-width: 90vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;

  .gl-dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;

    .gl-dialog-title {
      font-size: 18px;
      font-weight: 500;
    }
    .gl-dialog-close {
      font-size: 22px;
      color: #909399;
      cursor: pointer;
      &:hover {
        color: #303133;
      }
    }
  }

  .gl-dialog-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
  }

  .gl-dialog-footer {
    padding: 12px 20px;
    border-top: 1px solid #ebeef5;
    text-align: right;
  }
}
</style>
<!-- 页面使用 -->
<!-- <template>
  <div>
    <el-button @click="dialogVisible = true">打开弹窗</el-button>

    <gl-dialog
      :visible.sync="dialogVisible"
      title="我是弹窗标题"
      width="600px"
      :close-on-click-mask="true"
      @close="onDialogClose"
    >
      
      <div>这里放弹窗内容，可以表单、图片、表格</div>

      
      <template slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary">确定</el-button>
      </template>
    </gl-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    onDialogClose() {
      console.log('弹窗关闭')
    }
  }
}
</script> -->
